// @ts-ignore
import FosRouting from 'fos-routing'
import routes from 'RootAssets/v3/js/fos_js_routes.json'
FosRouting.setData(routes)
FosRouting.setScheme('https')

export default FosRouting

// // @ts-ignore
// //import Routing from 'FosRouting';
// const router = require('FosRouting/public/js/router.min.js');
// const routes = require('RootAssets/v3/js/fos_js_routes.json');
// router.setRoutingData(routes);
//
// // @ts-ignore
// //window.Routing = router
//
// module.exports = router
// // module.exports = {
// //     generate(name: string, parameters = {}, absolute = false) {
// //         // @ts-ignore
// //         return window.Routing.generate(name, parameters, absolute);
// //     },
// // };
